import Vue from 'vue';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.use(VuetifyGoogleAutocomplete, {
    apiKey: process.env.MIX_GOOGLE_MAP_API_KEY,
});
